'use client';

import {
    Alert,
    AlertState,
    Button,
    Image,
    Modal,
    Text,
    Title,
    TitleLevels,
    TrilogyColor,
    TypographyBold,
    View,
} from '@bytel/trilogy-react-ts';

interface BboxOtisOptionModalProps {
    onClose: () => void;
    active: boolean;
    onAddOtisRepeater: () => void;
    isRepeaterAdded: boolean;
    shouldShowAlert: boolean;
    repeaterPrice: number;
}

export default function BboxOtisOptionModal({
    onClose,
    active,
    onAddOtisRepeater,
    isRepeaterAdded,
    shouldShowAlert,
    repeaterPrice,
}: Readonly<BboxOtisOptionModalProps>) {
    return (
        <Modal active={active} onClose={onClose} closeIcon className='otis-modal'>
            <Title level={TitleLevels.TWO}>Répéteur WiFi 7</Title>
            <Text>
                Vous habitez un logement de plus de 80 m²&nbsp;? Il y a un étage chez vous&nbsp;? Disponible en option
                avec la B&YOU Pure fibre, le répéteur WiFi 7 tri-bandes vous garantit une couverture WiFi idéale&nbsp;!
            </Text>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>+ {repeaterPrice}€/mois</Text>
            <View className='has-text-centered mb-3 img-modal'>
                <Image
                    src='https://bouyguestelecom.fr/assets/media/full/image/CMS/ecommerce/byou/Repeteur.webp'
                    alt='Box'
                    width={160}
                    height={200}
                    className='is-centered'
                />
            </View>
            <Alert
                alert={AlertState.WARNING}
                display={shouldShowAlert}
                title="Ajoutez d'abord l'offre Pure Fibre"
                description="L'option répéteur WiFi est seulement compatible avec l'offre Pure Fibre. Ajoutez-la pour continuer !"
            />

            <View className='pt-4'>
                <Button
                    variant={TrilogyColor.PRIMARY}
                    className='oisBg is-fullwidth has-byou-background mb-4'
                    onClick={onAddOtisRepeater}
                >
                    {isRepeaterAdded ? 'Retirer du panier' : 'Ajouter au panier'}
                </Button>
                <Button variant={TrilogyColor.TERTIARY} className='oisBg is-fullwidth' onClick={onClose}>
                    Fermer
                </Button>
            </View>
        </Modal>
    );
}
